import { apiRequest } from '@/api/client';
import { pinnedLayout, pinnedPlaylist } from '@/playback/emergency';
import type { Layout, Playlist } from '@/lib/types';

const playlistCache = new Map<string, Playlist>();
const layoutCache = new Map<string, Layout>();

export async function loadPlaylist(id: string, force = false): Promise<Playlist> {
  if (!force) {
    const cached = playlistCache.get(id);
    if (cached) return cached;
  }
  try {
    const data = await apiRequest<Playlist>(`/player/playlists/${id}`);
    playlistCache.set(id, data);
    return data;
  } catch (err) {
    // The one content the player is not allowed to fail to resolve is its
    // emergency playlist, and the moment it is asked for is the moment the
    // network is least likely to answer. `playback/emergency.ts` keeps a
    // snapshot for exactly this call (D10).
    const pinned = pinnedPlaylist(id);
    if (pinned) return pinned;
    throw err;
  }
}

export async function loadLayout(id: string, force = false): Promise<Layout> {
  if (!force) {
    const cached = layoutCache.get(id);
    if (cached) return cached;
  }
  try {
    const data = await apiRequest<Layout>(`/player/layouts/${id}`);
    layoutCache.set(id, data);
    return data;
  } catch (err) {
    const pinned = pinnedLayout(id);
    if (pinned) return pinned;
    throw err;
  }
}

export function invalidatePlaylist(id: string): void {
  playlistCache.delete(id);
}

export function invalidateLayout(id: string): void {
  layoutCache.delete(id);
}
